// Shared pagination math used by both usePagination (server-side) and
// useClientPagination (client-side) so the page-count / clamping behaviour
// stays identical between them.

export const defaultPageSizeOptions = ['10', '15', '20'];

export const getNumberOfPages = (pageSize, totalItems) => {
  if (!pageSize || !totalItems) {
    return 0;
  }
  return Math.ceil(totalItems / pageSize);
};

export const getVisiblePage = (currentPage, nPages) => {
  if (!currentPage || !nPages) {
    return 1;
  }
  return Math.max(1, Math.min(currentPage, nPages));
};
